import { render, staticRenderFns } from "./ticketRolePlaceholder.vue?vue&type=template&id=c720c7ec&"
import script from "./ticketRolePlaceholder.vue?vue&type=script&lang=js&"
export * from "./ticketRolePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ticketRolePlaceholder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports